import React from 'react'
import PropTypes from 'prop-types';
import style from './style.css'

export default class NoDevicesView extends React.Component {

  render() {
    const { type } = this.props
    return ( 
      <div className={style.noItems}>{`This System has no ${type || 'Device'}s`}</div>
    );
  }
}
